import { useEffect, useState } from 'react';

import { Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, RadioGroup, Select, TextField, Typography } from '@mui/material';

import moment from 'moment';
import 'moment/locale/es-mx';

import { generar, GENERO, Persona } from 'curp-ts';

import { ObtenerClaveEntidad } from '../helpers/ObtenerClaveEntidad';

import { DialogContentStyle, DialogActionsStyle } from '../styles/DialogStyle';

import { AgregarPersona } from '../connections/comun/PersonaConnection';
import { ObtenerEstados } from '../connections/catalogos/EstadoConnection';

import { EstadoProps } from '../interfaces/catalogos/EstadoInterface';
import { AgregarPersonaParams, PersonaBusquedaProps } from '../interfaces/comun/PersonaInterface';

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
    seleccionarPersona:     ( persona: PersonaBusquedaProps ) => void;
}

interface Error {
    descripcion?:   string;
}

export const DialogNuevaPersona = ( { openDialog, handleCloseDialog, seleccionarPersona }: Props ) => {
 
    const [nombres, setNombres] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [fechaNacimiento, setFechaNacimiento] = useState( '' );
    const [curp, setCurp] = useState( '' );
    const [rfc, setRfc] = useState( '' );
    const [sexo, setSexo] = useState( 0 );
    const [tipoPersona, setTipoPersona] = useState( 1 );
    const [razonSocial, setRazonSocial] = useState( '' );

    const [entidadNacimiento, setEntidadNacimiento] = useState(0);
    const [entidadNacimientoArray, setEntidadNacimientoArray] = useState<EstadoProps[]>( [] );

    const [isLoading, setIsLoading] = useState( false );

    const [errors, setErrors] = useState<Error>({ });

    const handleClear = ( tipoPersona: number ) => {

        setNombres( '' );
        setApellido1( '' );
        setApellido2( '' );
        setFechaNacimiento( '' );
        setSexo( 0 );
        setEntidadNacimiento( 0 );
        setCurp( '' );
        setRfc( '' );
        setRazonSocial( '' );
        setTipoPersona( tipoPersona );

        setErrors( {} );
    }
  
    const Agregar = async () => {

        setIsLoading( true );

        const params: AgregarPersonaParams = {
            nombres: nombres,
            apellido1: apellido1,
            apellido2: apellido2,
            fechaNacimiento: fechaNacimiento,
            idSexo: sexo,
            idEntidadNacimiento: entidadNacimiento,
            curp: curp,
            rfc: rfc,
            idTipoPersona: tipoPersona,  
            razonSocial: razonSocial,            
        };

        await AgregarPersona( params ).then( resp => {

            const { success, message, idPersona, nombreCompleto, idTipoPersona } = resp;

            if( success ){
                
                setTimeout(() => {
                    
                    setIsLoading( false );

                    seleccionarPersona({ idPersona, idTipoPersona, nombreCompleto: nombreCompleto ?? '', curp });

                    handleClear( 1 );
                    handleCloseDialog();

                }, 700);

            }
            else{                    

                setTimeout(() => {

                    setErrors({ descripcion: message });
                    
                    setIsLoading( false );    

                }, 700); 
                
            }           

        });

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerEstados().then( resp => {  
                setEntidadNacimientoArray( resp );    
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
      
        if( nombres && apellido1 && apellido2 && fechaNacimiento && sexo !== 0 && entidadNacimiento !== 0 ){   

            const clave_estado = ObtenerClaveEntidad( 'Durango' );

            if( clave_estado ){

                const persona: Persona = {
                    nombre: nombres,
                    apellidoPaterno: apellido1,
                    apellidoMaterno: apellido2,
                    genero: sexo === 1 ? GENERO.MASCULINO : GENERO.FEMENINO,
                    fechaNacimiento: moment(fechaNacimiento).format('DD-MM-YYYY'),
                    estado: clave_estado.type,                                  
                }
                
                setCurp( generar(persona) );
            }
            else{
                setCurp( '' );
            }
            
        }
        else{
            setCurp( '' );
        }

    }, [ nombres, apellido1, apellido2, fechaNacimiento, sexo, entidadNacimiento ]);

    useEffect(() => {
      
        if( openDialog ){
            handleClear( 1 );
        }
        
    }, [ openDialog ])   
    
    return (
        <>
            <Dialog 
                maxWidth='sm' 
                open={ openDialog } 
                fullWidth={true}           
            >

                <DialogTitle>
                    Agregar Persona
                </DialogTitle>
            
                <DialogContent sx={{ ...DialogContentStyle, height: 450, }}>
                    
                    <Grid container spacing={3}>                    
                       
                        <Grid size={{ md: 4, xs: 1 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                            <FormLabel>Tipo de persona: </FormLabel>
                        </Grid>
                        
                        <Grid size={{ md: 8, xs: 10 }}>
                            <RadioGroup row>
                                <Grid container sx={{ width: '100%' }}>
                                    <Grid size={{ md: 6, xs: 6 }}>
                                        <FormControlLabel value="Física" control={ <Checkbox checked={ tipoPersona === 1 } onChange={ () => handleClear( 1 ) } /> } label="Física" />
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 6 }}>
                                        <FormControlLabel value="Moral" control={ <Checkbox checked={ tipoPersona === 2 } onChange={ () => handleClear( 2 ) } /> } label="Moral" />     
                                    </Grid>                                                            
                                </Grid>
                            </RadioGroup>
                        </Grid>          

                        {
                            
                            tipoPersona === 1   
                            && 
                            (
                                <>

                                    <Grid size={{ md: 12, xs: 12 }} >
                                        <TextField
                                            fullWidth
                                            label="Nombre(s)"
                                            name="nombres"
                                            variant="outlined"        
                                            required     
                                            autoComplete="off"   
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}                 
                                            value={ nombres }   
                                            onChange={ ( e ) => { setNombres( e.target.value.toUpperCase() ); } }
                                        />
                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }} >
                                        <TextField
                                            fullWidth
                                            required       
                                            label="Apellido 1"
                                            name="apellido1"
                                            variant="outlined"             
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}   
                                            value={ apellido1 }     
                                            onChange={ ( e ) => { setApellido1( e.target.value.toUpperCase() ); } }                      
                                        />
                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }} >
                                        <TextField
                                            fullWidth
                                            label="Apellido 2"
                                            name="apellido2"
                                            variant="outlined"           
                                            autoComplete="off"                                             
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}                       
                                            value={ apellido2 }  
                                            onChange={ ( e ) => { setApellido2( e.target.value.toUpperCase() ); } }                            
                                        />
                                    </Grid>                         

                                    <Grid size={{ md: 6, xs: 12 }} >
                                        <TextField
                                            label="Fecha nacimiento"
                                            type="date"
                                            fullWidth
                                            slotProps={{
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}   
                                            value={ fechaNacimiento }                   
                                            onChange={ ( e ) => { setFechaNacimiento( e.target.value ); } }     
                                        />
                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }} >                            
                                        <FormControl fullWidth>
                                            <InputLabel id="select-entidadNacimiento-label">Entidad de nacimiento</InputLabel>
                                        
                                            <Select
                                                labelId="select-entidadNacimiento-label"
                                                id="select-entidadNacimiento"                                            
                                                label="Entidad de nacimiento"
                                                name="entidadNacimiento"
                                                value={ entidadNacimiento}
                                                onChange={ (e) => setEntidadNacimiento( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            >
                                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem> 
                                                {
                                                    entidadNacimientoArray.map( ({ idEstado, descripcion }) => (
                                                        <MenuItem key={idEstado} value={idEstado}>{ descripcion }</MenuItem>        
                                                    ))
                                                }                                      
                                            </Select>

                                        </FormControl>
                                    </Grid>   

                                    <Grid size={{ md: 6, xs: 12 }} >
                                        <FormControl fullWidth>
                                            
                                            <Grid container spacing={3}>
                                                
                                                <Grid size={{ md: 2, xs: 2 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                                                    <FormLabel sx={{ color: 'black' }} >Sexo: </FormLabel>
                                                </Grid>
                                                
                                                <Grid size={{ md: 10, xs: 10 }} >
                                                    <RadioGroup row sx={{ textAlign: 'center' }} >
                                                        <Grid container >
                                                            <Grid size={{ md: 6, xs: 6 }} >
                                                                <FormControlLabel value="Hombre" control={ <Checkbox checked={ sexo === 1 } onChange={ () => { setSexo(1) } } /> } label="Hombre" />
                                                            </Grid>
                                                            <Grid size={{ md: 6, xs: 6 }} >
                                                                <FormControlLabel value="Mujer" control={ <Checkbox checked={ sexo === 2 } onChange={ () => { setSexo(2) } } /> } label="Mujer" />     
                                                            </Grid>                                                            
                                                        </Grid>
                                                    </RadioGroup>
                                                </Grid>

                                            </Grid>

                                        </FormControl>
                                  
                                    </Grid>                           

                                    <Grid size={{ md: 6, xs: 6 }} >
                                        <TextField
                                            fullWidth
                                            required
                                            label="Curp"
                                            name="curp"
                                            variant="outlined"
                                            autoComplete="off"          
                                            slotProps={{
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}         
                                            value={ curp }                   
                                            onChange={ ( e ) => { setCurp( e.target.value.toUpperCase() ); } }                                       
                                        />
                                    </Grid>
                                    
                                </>
                            )
                        }

                        {
                            tipoPersona === 2                    
                            && 
                            (
                                <>

                                    <Grid size={{ md: 12, xs: 12 }} >
                                        <TextField
                                            fullWidth
                                            label="Razon social"
                                            name="razonSocial"
                                            variant="outlined"    
                                            required 
                                            autoComplete="off"        
                                            slotProps={{
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}                        
                                            value={ razonSocial }      
                                            onChange={ ( e ) => { setRazonSocial( e.target.value.toUpperCase() ); } }                       
                                        />
                                    </Grid>

                                    <Grid size={{ md: 6, xs: 6 }}>
                                        <TextField
                                            fullWidth
                                            required                
                                            label="RFC"
                                            name="rfc"
                                            variant="outlined"     
                                            autoComplete="off"                
                                            slotProps={{
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}   
                                            value={ rfc }   
                                            onChange={ ( e ) => { setRfc( e.target.value.toUpperCase() ); } }       
                                        />
                                    </Grid>
                                
                                </>
                            )
                        }                 

                        <Grid size={{ md: 12, xs: 12 }} >
                            <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>* Campos obligatorios</Typography>
                        </Grid>

                        {   
                            errors.descripcion && ( 
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Alert severity="error" variant="filled" > { errors.descripcion } </Alert> 
                                </Grid>
                            )
                        }    
                        
                    </Grid>
                    
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button 
                        color="secondary" 
                        onClick={ handleCloseDialog }
                    >
                        Cancelar
                    </Button>
                    <Button 
                        variant='contained' 
                        onClick={ Agregar } 
                        loading={ isLoading }
                        disabled={
                            tipoPersona === 2
                            ?
                                razonSocial === ''
                            :
                                nombres === '' || apellido1 === '' || fechaNacimiento === '' || entidadNacimiento === 0 || sexo === 0
                        }
                    >
                        Agregar
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}